import { FC, useEffect, useState } from "react";
import Logo from "assets/Images/Header/BlackSLogo.svg";
import { Image, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import CustomNoData from "./CustomNoData";

const CountinueOnMobileApp: FC<{
  children: any;
  desc?: string;
  isShowDesc: boolean;
  isShowChildren:boolean
  useInWeb?:boolean
  noDataSrc?:string
}> = ({ children, desc, isShowDesc,isShowChildren,useInWeb,noDataSrc}) => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    setIsMobile(isAndroid || isIOS);
  }, []);

  const openMobileApp = () => {
    const mobileAppLink = "myapp://open"; // Uygulamanızın deep linki
    const appStoreLink = "https://apps.apple.com/app/myapp";
    const playStoreLink =
      "https://play.google.com/store/apps/details?id=com.myapp";

    window.location.href = mobileAppLink;

    setTimeout(() => {
      if (isMobile) {
        window.location.href = isMobile ? appStoreLink : playStoreLink;
      }
    }, 2000);
  };

  const { Text } = Typography;

  if (isMobile === null) {
    return null;
  }

  return !isMobile ? (
    <>{children}</>
  ) : (
    <>
 
      {isShowDesc && (
        <CustomNoData
          description={desc || "Devam etmek için mobil uygulamamızı kullanın"}
          noDataSrc={noDataSrc}
        />
      )}
    <div className="fixed top-0 left-0 w-full h-screen flex items-center justify-center z-50 pointer-events-none">
      <div className="w-full bg-white p-4 fixed bottom-14 left-0 shadow-xl pointer-events-auto">
        <div
          className="flex items-center gap-2"
          onClick={() => {
            if(!useInWeb)
            {

              openMobileApp();
            }
          }}
        >
          <div className="relative w-[50px] h-[50px] flex items-center justify-center bg-[#FFC502] rounded-full p-2">
            <Image
              preview={false}
              src={Logo}
              alt="loading"
              width={30}
              height={30}
            />
          </div>
          <Text className="text-xs text-blue-500">
            {desc || "Devam etmek için mobil uygulamamızı kullanın"}
          </Text>
        </div>
      </div>
    </div>
    </>
  );
  
};

export default CountinueOnMobileApp;
